export default "__VITE_ASSET__DV3$azDU__"